import { render, staticRenderFns } from "./addVehicleInsuranceDetails.vue?vue&type=template&id=327c6fcb"
import script from "./addVehicleInsuranceDetails.vue?vue&type=script&lang=js"
export * from "./addVehicleInsuranceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports